import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#fff",
    "fill-opacity": ".5",
    d: "M.553 4.106a1 1 0 0 1 1.341.446l.01.017.053.095c.052.088.135.22.25.383.23.326.588.766 1.083 1.206C4.27 7.125 5.793 8 8 8s3.73-.875 4.71-1.747c.496-.44.853-.88 1.084-1.206a6 6 0 0 0 .303-.478l.01-.019v-.001a1 1 0 0 1 1.788.898c-1.493-.746 0 0 0 .001l-.002.003-.003.006-.008.016a3 3 0 0 1-.116.207c-.077.13-.19.31-.34.523a9.2 9.2 0 0 1-1.42 1.574l.888 1.776a1 1 0 0 1-1.789.894l-.756-1.513A8.9 8.9 0 0 1 9 9.95V12a1 1 0 1 1-2 0V9.95a8.9 8.9 0 0 1-3.349-1.017l-.756 1.514a1 1 0 0 1-1.79-.894l.889-1.776-.033-.03A9.2 9.2 0 0 1 .575 6.203a8 8 0 0 1-.456-.73l-.008-.016-.003-.006-.001-.002C.105 5.446 1.598 4.7.105 5.446a1 1 0 0 1 .447-1.341"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h16v16H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }